(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('ThreatExtractedEmailsController', ["$scope", "path", "modulesManager", "tablePaginationHelper", "fileDao", "routeHelper", "objectTypeDao", "$q", "modals", "remediationProperties", "manualActionDao", "sideMenuManager", "entityTypes", "emailDao", "$route", "feature", "widgetSettings", "columnsHelper", "$routeParams", "$timeout", "$interval", function ($scope, path, modulesManager, tablePaginationHelper, fileDao, routeHelper, objectTypeDao, $q, modals, remediationProperties, manualActionDao, sideMenuManager, entityTypes, emailDao, $route, feature, widgetSettings, columnsHelper, $routeParams, $timeout, $interval) {
        $scope.model = { currentModule: $routeParams.module };
        $scope.loadedPagination = false;
        $scope.totalCount = 0;
        $scope.enabledSaases = [];
        var watcherAutoUpdateFirst, watcherAutoUpdateSecond, checkingIsRestored;
        function initVariables(indicator, force) {
            $scope.firstAPISuccess = false;
            if (indicator) {
                $scope.loading = true;
                $scope.loadingInfoText = true;
            }
            if (force) {
                $scope.updatedRows = {};
                $scope.processingActions = {};
            }
        }
        initVariables(true, true);
        var availableSaases = [
            'office365_emails',
            'google_mail'
        ];
        modulesManager.init().then(function () {
            $scope.enabledSaases = _(modulesManager.activeSaasApps()).filter(function (saas) {
                return _(availableSaases).contains(saas.name);
            }).map(function (saas) {
                return $.extend({ href: routeHelper.getHref('threat-extracted-emails', { module: saas.name }) }, saas);
            });
        });
        function updateRowClasses() {
            if (!$scope.tableModel || !$scope.tableModel.data) {
                return;
            }
            var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
            _($scope.tableModel.data).each(function (row, idx) {
                $scope.tableModel.rowClasses[idx] = $scope.tableModel.rowClasses[idx] || {};
                if ($scope.processingActions[row[primaryColumn].originalText]) {
                    $scope.tableModel.rowClasses[idx].processing = true;
                } else {
                    delete $scope.tableModel.rowClasses[idx].processing;
                }
            });
        }
        $scope.reload = function () {
            var staticFilePostfix = '';
            if ($scope.model.currentModule == 'office365_emails') {
                staticFilePostfix = '.email';
            }
            if ($scope.enabledSaases.length) {
                var currentModuleEnabled = _($scope.enabledSaases).find(function (saas) {
                    return saas.name === $scope.model.currentModule;
                });
                if (!currentModuleEnabled) {
                    routeHelper.redirectTo('threat-extracted-emails', { module: $scope.enabledSaases[0].name });
                    return;
                }
            } else {
                return $timeout(function () {
                    $scope.reload();
                }, 1000);
            }
            $scope.resultsPanel = {
                title: 'Loading...',
                'class': 'light white-body white-header',
                'bodyStyle': { 'min-height': '500px' }
            };
            $scope.tableOptions = {
                asDivs: true,
                disableTop: true,
                disableTotalRows: true,
                dropdownHeader: true,
                infinite: true,
                orderDisplayMode: 'highlight-column',
                pagesAround: 2,
                pagination: {
                    pageSize: 20,
                    ordering: {}
                },
                reloadSecondAPI: false,
                reloadUuid: true,
                saveState: true,
                showWorkingIndicator: false,
                workingIndicatorDisableGui: false
            };
            function updateColumns(options, changeObject) {
                if ($scope.resultsPanel.uuid && $scope.resultsPanel.filters) {
                    var filterParams = widgetSettings.params($scope.resultsPanel.uuid);
                    var newColumns = _(options.columns).map(function (column) {
                        if (column.showIf) {
                            if (filterParams[column.showIf]) {
                                delete column.hidden;
                            } else {
                                column.hidden = true;
                            }
                        }
                        return column;
                    });
                    if (changeObject) {
                        options.columns = newColumns;
                    }
                }
            }
            $q.all([
                objectTypeDao.retrieve(false),
                path('gui-v2').ctrl('threat-extracted-emails').json($scope.model.currentModule + '.threat-extracted').retrieve()
            ]).then(function (responses) {
                $scope.options = responses[1].data;
                $scope.options.localEntity = 'email';
                $scope.resultsPanel.filters = $scope.options.filters;
                $scope.resultsPanel.uuid = $scope.options.uuid;
                if ($scope.options.entityType) {
                    $scope.sources = responses[0].data.sources($scope.options.entityType);
                    $scope.actionTypes = responses[0].data.actionTypes[$scope.options.entityType];
                    var restoreAction;
                    if (_($scope.options.restoreFeature).isUndefined() || feature[$scope.options.restoreFeature]) {
                        var restoreActionIds = $scope.options.restoreActionIds;
                        if (!restoreActionIds && $scope.options.restoreActionId) {
                            restoreActionIds = [$scope.options.restoreActionId];
                        }
                        _(restoreActionIds).find(function (actionId) {
                            restoreAction = _($scope.actionTypes).find(function (action) {
                                return action.id === actionId;
                            });
                            return restoreAction;
                        });
                    }
                    if ($scope.options.restoreActionId && (_($scope.options.restoreFeature).isUndefined() || feature[$scope.options.restoreFeature])) {
                        restoreAction = _($scope.actionTypes).find(function (action) {
                            return action.id === $scope.options.restoreActionId;
                        });
                    }
                    if (restoreAction) {
                        $scope.restoreButton = {
                            label: 'Restore...',
                            display: 'button',
                            active: function () {
                                return $scope.tableHelper.getSelectedIds().length > 0;
                            },
                            execute: function () {
                                modals.params([{
                                        params: _(restoreAction.attributes).chain().filter(function (param) {
                                            return _(param.label).isString();
                                        }).map(function (param) {
                                            return $.extend(true, {}, param);
                                        }).value(),
                                        lastPage: true,
                                        getProperties: _.memoize(remediationProperties($scope.sources.properties))
                                    }], restoreAction.label, restoreAction.size, { noDataLabel: restoreAction.confirm }).then(function (data) {
                                    var body = {
                                        name: restoreAction.id,
                                        attributes: data
                                    };
                                    manualActionDao.create($scope.options.entityType, $scope.tableHelper.getSelectedIds(), body).then(function () {
                                        _($scope.tableHelper.getSelectedIds()).each(function (id) {
                                            $scope.processingActions[id] = true;
                                        });
                                        updateRowClasses();
                                        $scope.tableHelper.clearSelection();
                                        checkingIsRestored = $interval(function () {
                                            if (_($scope.processingActions).isEmpty()) {
                                                $interval.cancel(checkingIsRestored);
                                            } else {
                                                _($scope.processingActions).each(function (value, id) {
                                                    emailDao.threatExtractedEmail_detail(null, id).then(function (response) {
                                                        if (response.data && response.data.rows && response.data.rows[0].is_attachment_restored) {
                                                            var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
                                                            var idx = _($scope.tableModel.data).findIndex(function (row) {
                                                                return row[primaryColumn].originalText === id;
                                                            });
                                                            if (idx !== -1) {
                                                                delete $scope.tableModel.rowClasses[idx].processing;
                                                                $scope.tableModel.data.splice(idx, 1);
                                                                delete $scope.updatedRows[idx];
                                                                delete $scope.processingActions[id];
                                                                if ($scope.totalCount > 0) {
                                                                    $scope.tableOptions.infoText = $scope.totalCount - 1 + ' extracted ' + $scope.options.localEntity + 's';
                                                                }
                                                            }
                                                        }
                                                    });
                                                });
                                            }
                                        }, 2000);
                                    });
                                });
                            }
                        };
                    }
                    $scope.tableOptions.actions = [$scope.restoreButton];
                }
                updateColumns($scope.options);
                // getting Total rows
                var timeoutGetTotal = $q.defer();
                emailDao.threatExtractedEmails_getTotal().timeout(timeoutGetTotal.promise).then(function (res) {
                    $scope.loadingInfoText = false;
                    $scope.totalCount = res.data.total_rows || 0;
                    $scope.tableOptions.infoText = $scope.totalCount + ' extracted ' + $scope.options.localEntity + 's';
                }).catch(function () {
                    $scope.loadingInfoText = false;
                    $scope.tableOptions.infoText = 'Many extracted ' + $scope.options.localEntity + 's';
                });
                $timeout(function () {
                    timeoutGetTotal.resolve();
                }, 10000);
                if (!$scope.tableHelper) {
                    $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                        var q = emailDao.threatExtractedEmails($scope.options.columns);
                        if ($scope.resultsPanel.uuid && $scope.resultsPanel.filters) {
                            q.params(widgetSettings.params($scope.resultsPanel.uuid));
                        }
                        if (args.columnsFilters) {
                            q.params(columnsHelper.filtersToParams(args.columnsFilters));
                        }
                        return q.pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order);
                    }, function (tableModel) {
                        $scope.tableModel = tableModel;
                        $scope.loading = false;
                        $scope.firstAPISuccess = true;
                        if ($scope.restoreAutoUpdateAfter && $scope.restoreAutoUpdateAfter.isBefore(moment())) {
                            $scope.tableHelper.options.options.autoUpdate = $scope.options.options.autoUpdate;
                            $scope.restoreAutoUpdateAfter = null;
                        }
                    });
                } else {
                    initVariables(false, true);
                    $scope.tableHelper.reload();
                }
                $scope.resultsPanel.forceUpdate = function () {
                    updateColumns($scope.tableHelper.options);
                    updateColumns($scope.options);
                    $scope.tableHelper.clearSelection();
                    initVariables(false, true);
                    $scope.tableHelper.reload();
                };
            });
            sideMenuManager.treeNavigationPath([
                'configuration',
                'threat-extracted-emails'
            ]);
        };
        $scope.$watch('firstAPISuccess', function (newValue) {
            if (newValue && $scope.tableModel && $scope.tableModel.data) {
                var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
                _($scope.tableModel.data).each(function (row, idx) {
                    if (!$scope.updatedRows[idx] && row[primaryColumn].originalText) {
                        emailDao.threatExtractedEmail_detail($scope.options.columns, row[primaryColumn].originalText).then(function (response) {
                            if (response.data && response.data.data && response.data.data.length) {
                                $scope.tableModel.data[idx] = response.data.data[0];
                                $scope.updatedRows[idx] = true;
                            }
                        });
                    }
                });
                $scope.tableOptions.reloadSecondAPI = false;
                $scope.tableOptions.firstAPISuccess = false;
                initVariables();
            }
        });
        function initWatchers() {
            $scope.$watch(function () {
                return $scope.tableOptions.pagination.ordering;
            }, function (newValue, oldValue) {
                if (oldValue !== newValue && !$scope.tableOptions.orderingChangedEvent) {
                    initVariables(false, true);
                }
            }, true);
            $scope.$watch(function () {
                return $scope.tableOptions.pagination.columnsFilters;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue && !$scope.tableOptions.eventOnFilterChange && !$scope.tableOptions.pagination.columnsFilterNoReload) {
                    initVariables(false, true);
                }
            }, true);
            watcherAutoUpdateSecond = $scope.$watch(function () {
                return $scope.tableOptions.reloadSecondAPI;
            }, function (newValue) {
                if (newValue) {
                    initVariables(false, true);
                }
            });
            watcherAutoUpdateFirst = $scope.$watch(function () {
                return $scope.tableOptions.firstAPISuccess;
            }, function (newValue) {
                if (newValue) {
                    $scope.firstAPISuccess = true;
                }
            });
        }
        $scope.$watch(function () {
            return $scope.tableOptions;
        }, function (newValue, oldValue) {
            if (oldValue !== newValue && !$scope.loadedPagination) {
                initWatchers();
                $scope.loadedPagination = true;
            }
        }, true);
        $scope.$watch('model.currentModule', function (newVal, oldVal) {
            if (newVal != oldVal) {
                routeHelper.redirectTo('threat-extracted-emails', { module: $scope.model.currentModule }, { replace: true });
            }
            $scope.tableModel = null;
            initVariables(false, true);
            $scope.reload();
        });
    }]);
}());